(function () {
  var container = document.querySelector('[data-section-type="menu-buttons"]');
  if (!container) return;
  var items = container.querySelectorAll('.js-button-item');
  var isTouchDevice = window.matchMedia('(hover: none)').matches;

  if (isTouchDevice) {
    // Mobile: keep click behavior
    items.forEach(function (item) {
      var trigger = item.querySelector('.js-btn-active');
      var dropdown = item.querySelector('.dropdown-menu');
      if (!trigger || !dropdown) return;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var isActive = item.classList.contains('active');
        items.forEach(function (el) { el.classList.remove('active'); });
        if (!isActive) item.classList.add('active');
      });
    });
    document.addEventListener('click', function (e) {
      if (!container.contains(e.target)) {
        items.forEach(function (el) { el.classList.remove('active'); });
      }
    }, true);
  } else {
    // Desktop: hover behavior
    items.forEach(function (item) {
      var dropdown = item.querySelector('.dropdown-menu');
      if (!dropdown) return;
      item.addEventListener('mouseenter', function () {
        items.forEach(function (el) { el.classList.remove('active'); });
        item.classList.add('active');
      });
      item.addEventListener('mouseleave', function () {
        item.classList.remove('active');
      });
    });
  }
})();
